import React from "react";
import { useTranslation } from "react-i18next";
import { TYPE } from "../../../../../../../constant";
import { useUserInfo } from "../../../../../../../hooks";

const Tip = () => {

  const { t } = useTranslation();
  const { info } = useUserInfo();

  return (
    <>
      <div className="btn_wrap">
        <div className="pos_lft">
          <button className="bg_wht blue del off"></button>
          <button className="bg_wht blue prev off"></button>
          {/* <button className="bg_wht blue next off"></button> */}
        </div>
        <div className="pos_rgt">
          <button className="bg_wht blue pen off"></button>
          <button className="bg_wht blue eraser off"></button>
        </div>
      </div>

      <div className="tutorial_notes">
        <div className="area top1">
          <img className="arr" src={ `${ process.env.PUBLIC_URL }/static/images/common/ic_tutorial_th_top1-1.svg`} alt="" />
          <img className="arr_m" src={ `${ process.env.PUBLIC_URL }/static/images/common/ic_tutorial_mo_top1-1.svg`} alt="" />
          <p className="tutor_txt1">{t('LC_05_17.msg010')}</p>
          <p className="tutor_txt2">{t('LC_05_17.msg011')}</p>
        </div>

        <div className="area top2">
          <img className="arr" src={ `${ process.env.PUBLIC_URL }/static/images/common/ic_tutorial_th_top1-2.svg`} alt="" />
          <img className="arr_m" src={ `${ process.env.PUBLIC_URL }/static/images/common/ic_tutorial_mo_top1-2.svg`} alt="" />
          <p className="tutor_txt1" dangerouslySetInnerHTML={{ __html: t('LC_05_17.msg012') }}/>
          <p className="tutor_txt2">{t('LC_05_17.msg013')}</p>
        </div>

        <div className="area center">
          <img className="img1" src={ `${ process.env.PUBLIC_URL }/static/images/common/img_tutorial_write.png`} alt="" />
          <p className="tutor_txt" dangerouslySetInnerHTML={{ __html: t('LC_05_17.msg006') }}/>
        </div>
        <div className="area btm1">
          <img className="arr" src={ `${ process.env.PUBLIC_URL }/static/images/common/ic_tutorial_th_btm1-1.svg`} alt="" />
          <img className="arr_m" src={ `${ process.env.PUBLIC_URL }/static/images/common/ic_tutorial_mo_btm1-1.svg`} alt="" />
          <p className="tutor_txt">{t('LC_05_17.msg007')}</p>
        </div>
        {
          info.channelCode !== TYPE.CHANNEL.GLOBAL01 && (
            <div className="area btm2">
              <img className="arr" src={ `${ process.env.PUBLIC_URL }/static/images/common/ic_tutorial_th_btm1-2.svg`} alt="" />
              <img className="arr_m" src={ `${ process.env.PUBLIC_URL }/static/images/common/ic_tutorial_mo_btm1-2.svg`} alt="" />
              <p className="tutor_txt" dangerouslySetInnerHTML={{ __html: t('LC_05_17.msg009') }}/>
            </div>
          )
        }
      </div>
    </>
    // <div className="tutorial_notes">
    //   <div className="area1">
    //     <img className="arr" src={ `${ process.env.PUBLIC_URL }/static/images/common/ic_tutorial_ar_01.svg` } alt="" />
    //     <img className="arr_m" src={ `${ process.env.PUBLIC_URL }/static/images/common/ic_tutorial_ar_05.svg` } alt="" />
    //     <p className="tutor_txt">{ t( 'LC_05_17.msg005' ) }</p>
    //   </div>
    //   <div className="area2">
    //     <img className="img1" src={ `${ process.env.PUBLIC_URL }/static/images/common/img_tutorial_write.png` } alt="" />
    //     <p className="tutor_txt" dangerouslySetInnerHTML={ { __html : t( 'LC_05_17.msg006' ) } } />
    //   </div>
    //   <div className="area3">
    //     <img className="arr" src={ `${ process.env.PUBLIC_URL }/static/images/common/ic_tutorial_ar_06_2.svg` } alt="" />
    //     <p className="tutor_txt">{ t( 'LC_05_17.msg007' ) }</p>
    //   </div>
    //   {/* <div className="area5">
    //     <img className="arr" src={ `${ process.env.PUBLIC_URL }/static/images/common/ic_tutorial_ar_06_tv.svg` } alt="" />
    //     <p className="tutor_txt">{ t( 'LC_05_17.msg008' ) }</p>
    //   </div> */}
    //   <div className="area7">
    //     <img className="arr" src={ `${ process.env.PUBLIC_URL }/static/images/common/ic_tutorial_ar_06_2.svg` } alt="" />
    //     <p className="tutor_txt" dangerouslySetInnerHTML={ { __html : t( 'LC_05_17.msg009' ) } } />
    //   </div>
    // </div>
  );

};

export default Tip;
